import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import Cookie from 'js-cookie'

if (process.env.REACT_APP_PROXY_POLKA) {
  if (!Cookie.get('XSRF-TOKEN')) {
    fetch('/login/authenticate', {
      method: 'POST',
      body: new URLSearchParams({
        UserId: process.env.REACT_APP_PROXY_POLKA_USER_ID,
        UserPwd: process.env.REACT_APP_PROXY_POLKA_USER_PWD,
      }),
    }).then(res => console.log(res))
  }
}

if (process.env.REACT_APP_MOCK_FETCH) {
  import('./apiMock').then(() => {
    ReactDOM.render(<App />, document.getElementById('root'))
  })
} else {
  ReactDOM.render(<App />, document.getElementById('root'))
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
